
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 100,
      filter: JSON.stringify([new Filter("courseItemGroupId", +this.$route.params.branchId)]),
    },
    className: "CourseItem",
  });

  companyObjectDataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.branchId,
    config: {},
    className: "CourseItemGroup",
  });
  
  courseDataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "course",
  });
  loaded: boolean = false;

  createItemModel: any = {
    courseId: +this.$route.params.id,
    courseItemGroupId: +this.$route.params.branchId,
    caption: "",
  };

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Раздел курсов",
        to: `/manage/courses/`,
        exact: true,
      },
      {
        text: this.courseDataSource.model?.caption,
        to: `/manage/courses/${this.courseDataSource.model?.id}/`,
        exact: true,
      },
      {
        text: this.companyObjectDataSource.model?.caption,
        disabled: true,
      },
    ];
  }

  created() {
    this.courseDataSource.get();
    this.companyObjectDataSource.get();
  }
}
